import { FC } from "react";
import { TaskAssignmentPayload } from "tm-shared/types";

import { GalleryUploader } from "@/domains/media";
import { PhotoCaptions } from "@/types/common";

import { StyledBlock } from "../../Styled";

interface PhotoProps {
    pointId: string;
    title: string;
    payload?: TaskAssignmentPayload;
    onUploadPhoto: (photo: string) => void;
    onDeletePhoto: (photoId: string) => void;

    captions: PhotoCaptions;
}

export const Photo: FC<PhotoProps> = ({
    pointId,
    title,
    payload,
    onUploadPhoto,
    onDeletePhoto,
    captions,
}) => {
    return (
        <StyledBlock>
            <GalleryUploader
                previewTitle={title}
                onUpload={onUploadPhoto}
                onDelete={onDeletePhoto}
                pointId={pointId}
                savedPhotos={payload?.photos ?? []}
                captionLines={captions}
            />
        </StyledBlock>
    );
};
